/**
 * Talala API Docs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface GetOffers404Response { 
    error_key?: GetOffers404Response.ErrorKeyEnum;
}
export namespace GetOffers404Response {
    export type ErrorKeyEnum = 'page.not_found';
    export const ErrorKeyEnum = {
        PageNotFound: 'page.not_found' as ErrorKeyEnum
    };
}


